type Listener = () => void;

let listeners: Listener[] = [];
let colors: Record<string, string> = {};

// Load from localStorage on init
try {
  const stored = localStorage.getItem('tagColors');
  if (stored) {
    colors = JSON.parse(stored);
  }
} catch {
  // ignore
}

function persist() {
  try {
    localStorage.setItem('tagColors', JSON.stringify(colors));
  } catch {
    // ignore
  }
}

export const tagColorsStore = {
  getColors: (): Record<string, string> => ({ ...colors }),
  setColor: (tag: string, color: string) => {
    colors = { ...colors, [tag]: color };
    persist();
    listeners.forEach((fn) => fn());
  },
  removeColor: (tag: string) => {
    const next = { ...colors };
    delete next[tag];
    colors = next;
    persist();
    listeners.forEach((fn) => fn());
  },
  subscribe: (fn: Listener) => {
    listeners.push(fn);
    return () => {
      listeners = listeners.filter((f) => f !== fn);
    };
  },
};